const wsMapping = {
  p01: "روز صاف",
  n01: "شب صاف",
  p02: "روز قسمتی ابری",
  n02: "شب قسمتی ابری",
  p03: "روز نیمه ابری",
  n03: "شب نیمه ابری",
  p04: "تمام ابری",
  p05: "باران",
  p06: "رگبار باران",
  p07: "برف و باران",
  p08: "رگبار باران و برف",
  p09: "برف",
  p10: "رگبار برف",
  p11: "طوفان تندری",
  p12: "غبار آلود",
  p13: "مه",
  p14: "مه رقیق",
  p15: "گرد و خاک",
  p16: "طوفان ریزگرد",
  p17: "وزش باد",
  p18: "تندباد",
  p19: "تگرگ",
  p20: "در دسترس نمی باشد",
};

export default wsMapping;
